import styled from '@emotion/styled';
import { Modal } from 'antd';
import { useMemo } from 'react';
import { Table } from 'antd';
import { CheckCircleTwoTone, ExclamationCircleTwoTone } from '@ant-design/icons';
import Loader from 'components/molecules/Loader';
import TableErrorBox from 'components/molecules/ErrorBox/TableErrorBox';

const CustomModal = styled(Modal)`
    .ant-modal-body {
        padding: 0;
    }
    .ant-modal-content {
        padding: 12px 16px;
        border-radius: 8px !important;
    }
    .ant-modal-header {
        padding: 8px 12px;

        border-bottom: none !important;
    }
    .ant-modal-footer {
        border-top: none !important;
        padding: 16px 0 8px 0;
    }
    .ant-modal-close-icon {
        position: relative;
        top: -2px;
    }
    .ant-modal-title {
        font-weight: 400 !important;
    }
    .ant-btn {
        border-radius: 8px !important;
    }
`;

const TableContainer = styled.div`
    background: #fafafa;
    border-radius: 8px;
    padding: 8px 0 0 0;
    box-shadow: none;
    margin-bottom: 0;
    height: 300px;
`;

const PublishPlanModal = ({
    open,
    setOpen,
    dataObject,
    onPublishPlan,
    confirmLoading,
    getPublishPromosLoading,
}: {
    open: boolean;
    setOpen: Function;
    dataObject: any;
    onPublishPlan: Function;
    confirmLoading: boolean;
    getPublishPromosLoading: boolean;
}) => {
    return (
        <CustomModal
            maskClosable={false}
            destroyOnClose
            centered
            open={open}
            width={980}
            title={<div className="flex items-center">{'Publish Plan'}</div>}
            onCancel={() => setOpen(false)}
            onOk={() => onPublishPlan()}
            okButtonProps={{ disabled: !dataObject?.length }}
            okText="Publish Now"
            cancelText="Close"
            confirmLoading={confirmLoading}
            style={{ borderRadius: 8 }}
        >
            <div>
                <div className="flex items-center mb-2">
                    <CheckCircleTwoTone twoToneColor="#52c41a" className="mr-2" />
                    <span className="font-semibold">Ready to publish ({dataObject?.length || 0})</span>
                </div>
                {getPublishPromosLoading ? (
                    <div style={{ height: 300, display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
                        <Loader />
                    </div>
                ) : (
                    <TableContainer>
                        <Table
                            size="small"
                            showHeader
                            bordered={false}
                            pagination={false}
                            dataSource={
                                dataObject?.map((item: any, idx: number) => ({
                                    key: idx,
                                    promo_name: item.promo_name,
                                    event_promo_id: item.event_promo_id,
                                    promo_type: item.promo_type,
                                    insert_type: item.insert_type,
                                    tpm_promo_id: item.tpm_promo_id,
                                    status: item.status,
                                })) || []
                            }
                            scroll={{ y: 300 }}
                            columns={[
                                {
                                    title: <span className="font-semibold text-gray-700">Promo name</span>,
                                    dataIndex: 'promo_name',
                                    key: 'promo_name',
                                    render: (text: string) => <span>{text}</span>,
                                },
                                {
                                    title: <span className="font-semibold text-gray-700">TPO ID</span>,
                                    dataIndex: 'event_promo_id',
                                    key: 'event_promo_id',
                                    render: (text: string) => <span>{text || '-'}</span>,
                                },
                                {
                                    title: <span className="font-semibold text-gray-700">Promo Type</span>,
                                    dataIndex: 'promo_type',
                                    key: 'promo_type',
                                    render: (text: string) => <span>{text || '-'}</span>,
                                },
                                {
                                    title: <span className="font-semibold text-gray-700">Update Indicator</span>,
                                    dataIndex: 'insert_type',
                                    key: 'insert_type',
                                    align: 'center',
                                    render: (text: string) => <span>{text || '-'}</span>,
                                },
                                {
                                    title: <span className="font-semibold text-gray-700">TPM Promo Id</span>,
                                    dataIndex: 'tpm_promo_id',
                                    key: 'tpm_promo_id',
                                    render: (text: string) => <span>{text || 'New'}</span>,
                                },
                                {
                                    title: <span className="font-semibold text-gray-700">Status</span>,
                                    dataIndex: 'status',
                                    key: 'status',
                                    render: (text: any) => (
                                        <span className="text-[#9254de] border border-[#d3adf7] rounded px-2 py-1 font-medium bg-[#f9f0ff] inline-block min-w-[60px] text-center break-words">
                                            {text}
                                        </span>
                                    ),
                                },
                            ]}
                            className="custom-table !border-none"
                            rowClassName={() => 'custom-table-row'}
                            locale={{
                                emptyText: getPublishPromosLoading ? (
                                    <></>
                                ) : dataObject.length === 0 ? (
                                    <TableErrorBox error={'NoMatchingRecords'} height={300} />
                                ) : (
                                    ''
                                ),
                            }}
                        />
                    </TableContainer>
                )}
            </div>
        </CustomModal>
    );
};

export default PublishPlanModal;
